module.exports = __webpack_public_path__ + "static/figure_platform-home-669e4905c407521e6989c0f66b4a8b70.png";